<template>
  <van-config-provider :theme="theme" class="app-main">
    <LoadingComponent ref="LoadingRef"></LoadingComponent>
    <GuideControlComponent ref="guideControlRef"></GuideControlComponent>
    <VanNavBar class="top-menus" @clickLeft="ToBack" v-show="route.meta?.HideNavbar == false" left-arrow
      :title="((route.meta?.Title ?? '未命名' + route.meta?.HideNavbar) as any)"></VanNavBar>
    <router-view v-if="isInit" />
  </van-config-provider>

</template>

<script lang="ts" setup>
import { getCurrentInstance, onMounted, ref } from 'vue';
import Global from '@/ts/Global';
import { useRoute } from 'vue-router';
import GuideControlComponent from '@/components/Templates/Controls/GuideControlComponent.vue';
import LoadingComponent from './components/LoadingComponent.vue';

import Tools from './ts/Tools';
import { ColorEnum } from './ts/SuperEnum';
import { ConfigProviderTheme } from 'vant';
import TTSPlayer from './ts/TTSPlayer';
import VoiceModelVO from './ts/vo/edgetts/VoiceModelVO';
import GuideMenuButtonVO from './ts/vo/GuideMenuButtonVO';

const theme = ref<ConfigProviderTheme>('dark');
const isInit = ref(false); //是否已经初始化完毕
const LoadingRef = ref<InstanceType<typeof LoadingComponent>>();
const guideControlRef = ref<InstanceType<typeof GuideControlComponent>>();
const route = useRoute();

const ToBack = () => {
  history.back();
};


onMounted(async () => {
  let _this = getCurrentInstance();
  if (_this) {
    Global.app = _this.exposed as any;
    isInit.value = true;
    Global.TryToLoginAsync();
  }
});

defineExpose({
  LoadingRef,
  guideControlRef
})

</script>

<style lang="scss">
:root {
  --color-text: #e0e0e0;
  --top-navigation-height: 68px;
  --left-navigation-width: 260px;
  --main-background: #0d1116;
  --theme-color-primary: #72e528;
  --theme-color-hover: #9ffd38;
  --el-text-color-regular: #ffffff;
  --el-color-primary: #72e528;
  --el-border-color-extra-light: var(--color-hover-background);
}
</style>

<style lang="scss">
@import url(https://at.alicdn.com/t/c/font_4808777_ld39oocn8rq.css);

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app-main {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
}


.van-theme-dark body {
  color: #f5f5f5;
  background-color: #0d1116;
}

body,
html,
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.iconfont {
  font-size: 30px;
}


.hui {
  filter: grayscale(100%) !important;
}

.g-font-color {
  color: #727485 !important;
}

.gb {
  background: linear-gradient(89.86deg, #a7ff1a, #82fac2, #47d4ff);
}

.gb-card {
  background: linear-gradient(135deg, #52ffba0a 9.27%, #23faec0a 46.96%, #00aaff0a 88.5%) !important;
}

.gb-card-select {
  background: linear-gradient(135deg, #52ffbaaa 9.27%, #23faecaa 46.96%, #00aaffaa 88.5%) !important;
}

.gb-font {
  background: linear-gradient(89.86deg, #a7ff1a, #82fac2, #47d4ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

.gb-panel {
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  background: linear-gradient(195.91deg, #2b444799, #171c24 50.49%, #182129 84.14%);
  width: 100%;
}

.mb {
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4); // 添加描边效果
}

.g-btn {
  background: linear-gradient(270deg, #1dd4f0, #1df5bb);
  color: #111214;
  border-radius: 8px;
  font-size: 24px;
  border: none;
}

// input{
//   border: 1px solid #82fac2;
//   background-color: transparent;
//   border: 0px;
// }

.top-menus {
  // display: flex;
  // justify-content: space-between;
  // height: 100px;
  // max-height: 100px;
}

.g-bl {
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.van-tab__text {
  // color: red !important;
}

.van-tabs {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.van-tabs__content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  .van-tab__panel {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .van-tabs {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
    }
  }
}

.van-tab--active .van-tab__text {
  background: linear-gradient(135deg, #52ffba 9.27%, #23faec 46.96%, #0af 88.5%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.van-tabs__line {
  transition: var(--bar-transition);
  margin-top: 4px;
  background: linear-gradient(135deg, #52ffba 9.27%, #23faec 46.96%, #0af 88.5%) !important;
  width: var(--bar-width);
  margin-left: var(--bar-left);
  height: 2px;
}

.van-overlay {
  backdrop-filter: blur(6px);
}


//手柄样式
.vue-drag-class {
  border: 1px solid red !important;
  -webkit-transition: background-color 200ms linear;
  -ms-transition: background-color 200ms linear;
  transition: background-color 200ms linear;
  position: absolute !important;
}

//拖拽时的样式
.vue-drag-dragging-class {
  background-color: rgb(30, 30, 30);
  border: 1px solid black;
}

//拉伸时的样式
.vue-drag-resizing-class {
  background-color: rgb(30, 30, 30);
  border: 1px solid black;
  color: white;
}


//激活时的样式
.vue-drag-active-class {
  border: 1px solid yellow !important;
  // -webkit-box-shadow: 10px 10px 5px 0px rgba(89, 237, 3, 0.75);
  // -moz-box-shadow: 10px 10px 5px 0px rgba(89, 237, 3, 0.75);
  // box-shadow: 10px 10px 5px 0px rgba(89, 237, 3, 0.75);
}

//手柄样式
.vue-drag-handle-class {
  position: absolute;
  border: 1px solid white;
  background-color: white;
  border-radius: 50%;
  height: 50px !important;
  width: 50px !important;
  font-size: 1em;
  line-height: 1em;
  box-sizing: border-box;
  transition: all .3s linear;


}


.vue-drag-handle-class-tl {
  top: calc(-50px / 2) !important;
  left: calc(-50px / 2) !important;
}

.vue-drag-handle-class-tm {
  top: calc(-50px / 2) !important;
  left: calc(50% - (50px / 2)) !important;
}

.vue-drag-handle-class-tr {
  top: calc(-50px / 2) !important;
  right: calc(-50px / 2) !important;
}

.vue-drag-handle-class-mr {
  top: calc(50% - 50px / 2) !important;
  right: calc(-50px / 2) !important;
}

.vue-drag-handle-class-br {
  right: calc(-50px / 2) !important;
  bottom: calc(-50px / 2) !important;
}

.vue-drag-handle-class-bm {
  right: calc(50% - 50px / 2) !important;
  bottom: calc(-50px / 2) !important;
}

.vue-drag-handle-class-bl {
  left: calc(-50px / 2) !important;
  bottom: calc(-50px / 2) !important;
}

.vue-drag-handle-class-ml {
  top: calc(50% - (50px / 2)) !important;
  left: calc(-50px / 2) !important;
}


.vue-drag-handle-class-rot {
  margin-bottom: 20px !important;
  // background-color: #0af !important;
  background-color: transparent !important;
  left: calc(50% - 50px / 2) !important;
  top: -90px !important;
  width: 50px !important;
  height: 50px !important;
  // bottom: -100px !important;
}

.vue-drag-handle-class-rot::before {
  content: "\e621";
  /* 替换为实际字体图标的 Unicode 编码 */
  font-family: "iconfont";
  /* 字体图标库的字体名称 */
  font-size: 100px;
  color: #999;
  position: absolute;
  top: 50%;
  left: 50%;
  color: white !important;
  transform: translate(-50%, -50%);
  opacity: 0.5;
  font-size: 40px;
}
</style>
